import React from 'react';
import { PERMISSION_STATUS } from '../../util/constants';

const Permissions = (props) => {
  const { arePermissionsAllowed, startGeolocation, startOrientation, startCamera,
    statusCamera, statusGeolocation, statusOrientation } = props;

  const permissions = [
    {
      name: "Orientation",
      status: statusOrientation.status,
      message: statusOrientation.message,
      startFunction: startOrientation
    },
    {
      name: "Geolocation",
      status: statusGeolocation.status,
      message: statusGeolocation.message,
      startFunction: startGeolocation
    },
    {
      name: "Camera",
      status: statusCamera.status,
      message: statusCamera.message,
      startFunction: startCamera
    },

  ]
  return (
    !arePermissionsAllowed ?
    <div className="permissions">
      <div className="content">
        <h4 className="font-app-title">Enable Permissions</h4>
          {permissions.map( item => (
            <>
              <div key={`permission-${item.name}`} className="row">
                <div>
                  <h3 className="font-app-subtitle">{item.name}</h3>
                  <p className="font-app-body">
                    Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  </p>
                </div>
                <button
                  disabled={item.status === PERMISSION_STATUS.INITIAL ? false : true}
                  onClick={item.startFunction}
                >
                  {item.status === PERMISSION_STATUS.LOADING ?
                    <div className="loader"/>
                  : item.status === PERMISSION_STATUS.CORRECT ?
                    <span className="checkmark">
                      <div className="checkmark_stem"></div>
                      <div className="checkmark_kick"></div>
                    </span>
                  : item.status === PERMISSION_STATUS.ERROR ? 
                    <span className="cross">X</span>
                  : "Enable"
                  }
                </button>
              </div>
              {item.message && <p className="font-app-body-error error-message">{item.message}</p>}
            </>
          ))}
      </div>
    </div>
    : null
  );
}

export default Permissions;
